import { dealershipPickerReducer } from '@makemydeal/dr-activities-dealership-picker';
import { dealershipPickerMiddleware } from './middleware';

export const dealershipPickerConfiguration = {
    middleware: dealershipPickerMiddleware,
    reducer: dealershipPickerReducer
};
